// The server label client — the UI half of `PUT /v1/runners/server-label` (#6556,
// body face `apps/api/src/routes/runner-server-label-body.ts`): one name for every
// machine on a physical server, all or none. `lib/box-lifecycle.ts` holds the
// single-box writes; this one addresses a SET (`runner_ids`, 1-500 distinct ids).
//
// `null` CLEARS the label, it is not a missing field: both keys are required on the
// wire, and an empty form field reaching this seam as `''` would be a 400, so the
// form maps blank to `null` before calling. No client validation beyond that — the
// server is the arbiter and its 400 `detail` is what the reader sees.
//
// THE MCP TWIN NAMES THE SET `box_ids`, NOT THE REST BODY'S `runner_ids` — the
// verb's own schema (`boxSetServerLabelVariant`, `packages/mcp/src/box-server-label.ts`)
// declares `box_ids`, and the copy button emits what the VERB takes, not what the
// REST body takes. `scripts/mcp-written-calls.test.ts` reads the argument NAMES.

import { type ApiCall, sendApiCall } from './api-call';
import { SESSION_TOKEN } from './session';

/** `PUT /v1/runners/server-label`'s answer: every id now carries this label. */
export type ServerLabelSet = {
  readonly runner_ids: readonly string[];
  readonly server_label: string | null;
};

export function setServerLabel(
  runnerIds: readonly string[],
  label: string | null,
  token: string | null = SESSION_TOKEN,
): Promise<ServerLabelSet> {
  return sendApiCall<ServerLabelSet>(serverLabelCall(runnerIds, label), token);
}

/** The label write as one value — fired by `setServerLabel`, shown by `<CopyAsCall/>`. */
export function serverLabelCall(runnerIds: readonly string[], label: string | null): ApiCall {
  return {
    capability: 'box.server_label',
    method: 'PUT',
    path: '/v1/runners/server-label',
    body: { runner_ids: [...runnerIds], server_label: label },
    mcp: {
      kind: 'verb',
      verb: 'box.set_server_label',
      arguments: { box_ids: [...runnerIds], server_label: label },
    },
  };
}
